import { render, staticRenderFns } from "./comCard2.vue?vue&type=template&id=7b32355c&scoped=true&"
import script from "./comCard2.vue?vue&type=script&lang=js&"
export * from "./comCard2.vue?vue&type=script&lang=js&"
import style0 from "./comCard2.vue?vue&type=style&index=0&id=7b32355c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32355c",
  null
  
)

export default component.exports